import {
    ModuleWithProviders,
    NgModule,
} from '@angular/core';
import {
    PageCategory,
    PageScope,
    providePageMeta,
} from '@app/router';

@NgModule()
export class JobMetaModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: JobMetaModule,
            providers: [
                providePageMeta({
                    title: 'Jobs',
                    translationKey: 'page_jobs',
                    routerLink: '/jobs',
                    sidebarSection: 'Monitoring',
                    svgIcon: 'uipath:jobs',
                    permission: 'Jobs.View',
                    type: 'Sidebar',
                    category: PageCategory.Tenant,
                    scope: PageScope.Folder,
                    priority: 1,
                }),
                providePageMeta({
                    title: 'Jobs',
                    translationKey: 'page_jobs',
                    routerLink: '/triggers/:id/jobs',
                    svgIcon: 'uipath:jobs',
                    permission: 'Jobs.View',
                    category: PageCategory.Tenant,
                    type: 'Breadcrumb',
                    parentRoute: '/triggers',
                    scope: PageScope.Folder,
                }),
            ],
        };
    }
}
